/**
 * Created by jv on 2019-10-15 (14:42).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

require("Styles/components/data-history.scss");

class DataHistory {
  constructor(options) {
    this.container = options.container ? $(options.container) : "body";
    this.$triggerElement = $(options.triggerElement);
    this.componentHtml = null;

    this.boundary = options.boundary || "window";
    this.trigger = options.trigger || "hover focus";

    this.calculations = options.calculations;
    this.total = options.total;

    this.placement = options.placement || "top";

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
  }

  create() {
    if (this._initialized !== true) {
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$triggerElement.popover({
        boundary: this.boundary,
        placement: this.placement,
        trigger: this.trigger,
        html: true,
        offset: "90%",
        template: "<div class='popover data-history-popover' role='tooltip'><div class='popover-arrow'></div><h3 class='popover-header'></h3><div class='popover-body'></div></div>",
        content: () => this.componentHtml
      });

      this.$triggerElement.popover("hide");

      this.setUpPopoverEventListeners();

      this._initialized = true;
    }
  }

  setComponentHtml(roundOverview, type) {
    if (utils.isNull(roundOverview)) return;
    let data = DataHistory.getDataHistoryForRound(roundOverview, type);

    this.calculations = data.calculations;
    this.total = data.total;

    try {
      let $element = $("<div class='data-history'></div>");
      if (utils.isNotNull(type)) {
        $element.addClass(`data-history__type-${type}`);
      }

      let $calculations = $("<div class='data-history__calculations'></div>");

      for (let i = 0; i < this.calculations.length; i++) {
        let calculation = this.calculations[i];

        let $row = $("<div class='data-history__row'></div>");
        $row.append(`<div class="data-history__label">${calculation.label}</div>`);
        $row.append(`<div class="data-history__value">${calculation.value}</div>`);

        $calculations.append($row);
      }

      $element.append($calculations);

      if (utils.isNotNull(this.total)) {
        let $dataHistoryTotal = $("<div class='data-history__total'></div>");

        let $row = $("<div class='data-history__row'></div>");
        $row.append(`<div class="data-history__label">${this.total.label}</div>`);
        $row.append(`<div class="data-history__value">${this.total.value}</div>`);

        $dataHistoryTotal.append($row);

        $element.append($dataHistoryTotal);
      }

      this.componentHtml = $element.prop("outerHTML");
    } catch (e) {
      log.error("Failed to render data history component - %o", e);
    }
  }

  show() {
    if (utils.isNotNull(this.$triggerElement) && this.$triggerElement.length && utils.isNotNull(this.componentHtml)) {
      if (utils.isNotNull(this.hideAnimationTimeout)) {
        clearTimeout(this.hideAnimationTimeout);
        this.hideAnimationTimeout = null;
      }

      this.$triggerElement.focus();
    }
  }

  hide() {
    if (utils.isNotNull(this.$triggerElement) && this.$triggerElement.length) {
      if (utils.isNotNull(this.hideAnimationTimeout)) {
        clearTimeout(this.hideAnimationTimeout);
        this.hideAnimationTimeout = null;
      }

      this.$triggerElement.popover("dispose");
    }
  }

  setUpPopoverEventListeners() {
    this.$triggerElement.on("hide.bs.popover", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.apply(this.callbackContext, this);
      }
    });
  }

  setUpEventListeners() {

  }

  static getDataHistoryForRound(roundOverview, type) {
    if (utils.isNull(roundOverview) || !utils.isArray(roundOverview.dataHistory) || roundOverview.dataHistory.length === 0) return null;

    let total = {};
    let calculations = [];

    if (type === "points") {
      for (let i = 0; i < roundOverview.dataHistory.length; i++) {
        let currentRoundDataHistory = roundOverview.dataHistory[i];

        // Skip quiz round
        if (i === 0) continue;

        let sign = currentRoundDataHistory.pointsGained >= 0 ? "+" : "";

        calculations.push({
          label: utils.format(LanguageManager.getValueForKey("serious_game.business_model.data_history.labels.round"), currentRoundDataHistory.roundIndex),
          value: sign + currentRoundDataHistory.pointsGained
        });

        if (roundOverview.dataHistory[i].roundIndex === roundOverview.currentRoundData.roundIndex) {
          total = {
            label: LanguageManager.getValueForKey("serious_game.business_model.data_history.labels.total_points"),
            value: currentRoundDataHistory.totalPoints
          };

          break;
        }
      }
    } else {
      let currentRoundDataHistory;
      let sign;

      for (let i = 0; i < roundOverview.dataHistory.length; i++) {
        if (roundOverview.dataHistory[i].roundIndex === roundOverview.currentRoundData.roundIndex) {
          currentRoundDataHistory = roundOverview.dataHistory[i];
          break;
        }
      }

      if (utils.isNull(currentRoundDataHistory)) return null;

      // Start budget
      calculations.push({
        label: LanguageManager.getValueForKey("serious_game.business_model.data_history.labels.start_budget"),
        value: currentRoundDataHistory.startBudget
      });

      // Start income
      sign = currentRoundDataHistory.startIncome >= 0 ? "+" : "";
      calculations.push({
        label: LanguageManager.getValueForKey("serious_game.business_model.data_history.labels.start_income"),
        value: sign + currentRoundDataHistory.startIncome
      });

      // Event
      if (utils.isNotNull(currentRoundDataHistory.eventBudgetEffect)) {
        sign = currentRoundDataHistory.eventBudgetEffect >= 0 ? "+" : "";

        calculations.push({
          label: LanguageManager.getValueForKey("serious_game.business_model.data_history.labels.event"),
          value: sign + currentRoundDataHistory.eventBudgetEffect
        });
      }

      // Subsidy
      if (utils.isNotNull(currentRoundDataHistory.subsidyBudget)) {
        sign = currentRoundDataHistory.subsidyBudget >= 0 ? "+" : "";

        calculations.push({
          label: LanguageManager.getValueForKey("serious_game.business_model.data_history.labels.subsidy"),
          value: sign + currentRoundDataHistory.subsidyBudget
        });
      }

      // Loaned
      if (utils.isNotNull(currentRoundDataHistory.loaned) && currentRoundDataHistory.loaned > 0) {
        sign = currentRoundDataHistory.loaned >= 0 ? "+" : "";

        calculations.push({
          label: LanguageManager.getValueForKey("serious_game.business_model.data_history.labels.loan"),
          value: sign + currentRoundDataHistory.loaned
        });
      }

      // Investments
      if (utils.isNotNull(currentRoundDataHistory.investmentBudgetEffect)) {
        sign = currentRoundDataHistory.investmentBudgetEffect >= 0 ? "+" : "";

        calculations.push({
          label: LanguageManager.getValueForKey("serious_game.business_model.data_history.labels.investments"),
          value: sign + currentRoundDataHistory.investmentBudgetEffect
        });
      }

      total = {
        label: LanguageManager.getValueForKey("serious_game.business_model.data_history.labels.total_budget"),
        value: currentRoundDataHistory.totalBudget
      };
    }

    return {
      calculations,
      total
    };
  }
}

export default DataHistory;



// WEBPACK FOOTER //
// ./app/js/components/game/components/data-history.js